<template>
    <div class="box">
        <div class="top" :style="'background-image:url('+dto.Src+');background-repeat: no-repeat;background-position-x: center; background-position-y: center;'">
        </div>
        <div class="center">
            <div class="tag">
                <p>
                    {{this.dto.Type}}
                </p>
            </div>
            <div class="text">
                <p class="title">
                    {{this.dto.Name}}
                </p>
                <p>
                    <span class="label">产品名称</span>
                    {{this.dto.Name}}
                </p>
                <p>
                    <span class="label">运输代码</span>
                    {{this.dto.Code}}
                </p>
                <p>
                    <span class="label">参考时效</span>
                    {{this.dto.Efficiency}}
                </p>
                <p>
                    <span class="label">包裹限重</span>
                   {{ '&lt;=' + dto.MaxWeight + 'KG' }}
                    <!-- {{'<='+this.dto.MaxWeight+'KG'}} -->
                </p>
                <p>
                    <span class="label">货件尺寸</span>
                    最大尺寸范围：{{this.dto.DimensionDescription}}
                </p>
                <p>
                    <span class="label new-line">计费方式</span>
                    <span v-html="this.dto.BillingDescriptionRich"></span>

                </p>
                <p>
                    <span class="label">走货属性</span>
                    {{this.dto.GoodsLimit}}
                </p>
                <p>
                    <span class="label">申报要求</span>
                    {{this.dto.DeclareDemand}}
                </p>
                <p>
                    <span class="label">派送范围</span>
                    {{this.dto.DeliveryRange}}
                </p>
                <p>
                    <span class="label">包装要求</span>
                    {{this.dto.PackingDemand}}
                </p>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .top
    {
        width:100%;
        height: 315px;
        background-position-y: center;
    }

    .center{
        width:1300px;
        box-sizing: border-box;
        padding:50px 50px 100px 50px;
        min-height: 800px;
        background-color: #ffffff;
        border-radius: 5px;
        margin:0 auto;
        margin-top:-40px;
    }

    .tag{
        display: inline-block;
        background-color: #004c73;
        border-radius: 100px 35px 35px 100px;
        padding: 8px 18px 8px 35px;
        margin-right: 10px;
        position: relative;
    }

    .tag p
    {
        font-size: 14px;
        color: #fff;
        margin: 0;
        border:none;
    }
    .tag p:before{
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #fff;
        position: absolute;
        left: 10px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
     .text p{
        padding: 30px 0;
        border-bottom: 1px solid #939393;
        margin: 0;
    }

    .text .title{
        font-weight: 800;
        font-size: 36px;
    }

    .text .label{
        font-weight: bold;
        margin-right: 50px;
    }
    .text .new-line{
        padding-bottom: 20px;
    }
</style>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      dto: {}
    }
  },
  name: 'ProductItem',
  created () {
    var that = this
    axios({url: 'http://wms.xingyunyi.cn/api/PublicChannel/GetChannelByName?name=' + this.$route.params.name, method: 'get', params: {}}).then(response => {
      that.dto = response.data.Data
      if (that.dto.ChannelType === 0) { that.dto.Type = '专线服务' } else if (that.dto.ChannelType === 1) { that.dto.Type = '快递服务' } else if (that.dto.ChannelType === 2) { that.dto.Type = '邮政服务' }
      that.dto.Src = that.dto.Image
    })

    // this.dto.Name = this.$route.params.name;
    // this.dto.Src = '/static/images/cs/3b0f95d6ed6a48e6b04cc9862ea226b4.jpg'
    // this.dto.Type = '专线服务';
    // this.dto.Code = 'USLine-6';
    // this.dto.Efficiency = '10-15工作日';
    // this.dto.MaxWeight = '30';
    // this.dto.MaxWidth = '60';
    // this.dto.MaxLength = '40';
    // this.dto.MaxHeight = '35';
    // this.dto.BillingDescription = '包裹实际重量和体积重量相比，取较大者计算（体积重量计算方式为:长*宽*高cm/8000=KG)；';
    // this.dto.GoodsLimit='不接受任何侵权产品、纯电、液体、粉末、危险品、枪支弹药等违禁品，可接受内置电池和配套电池。';
    // this.dto.DeclareDemand='我司不接受申报价值超过800美金的货物；且不接受同一个收件人名且同一地址，当天累计包裹申报价值超过800美金。';
    // this.dto.DeliveryRange = '全美，不包括阿拉斯加、夏威夷等偏远地区，波多黎各、关岛等境外地址；APO/FPO军事地址。';
    // this.dto.PackingDemand = '不接收圆柱形、不规则包装，标签需平整地贴在包裹的最大面。';
  }

}
</script>



// WEBPACK FOOTER //
// src/components/product.vue